import React from 'react';
import styled from 'styled-components';
import Tooltip from '../Tooltip/Tooltip';
import {FaTimes} from "react-icons/fa";

import { PopOut } from 'components'

const defaultStyle = {
    margin: '0.1rem',
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    iconColor: 'var(--secondary-accent-color)',
    color: 'var(--secondary-accent-color)',
}

const Container = styled.div`
    background: ${props => props.styles.backgroundColor};
    border: ${props => `1px solid ${props.styles.borderColor}`};
    margin: ${props => props.styles.margin};
    padding: 0.1rem 0.2rem;
    color: white;
    font-size: 0.7rem;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    /* :hover{
        filter: brightness(var(--brightness));
    } */
`

const Icon = styled.div`
    color: ${props => props.styles.iconColor};
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0.7rem;
    font-size: 0.7rem;
    margin: 0 0.2rem 0 0 !important;
`

const Tag = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    vertical-align: middle;
    color: ${props => props.styles.color};
`

const Properties = props => {
    const {
        style,
        label,
        icon,
        img,
        tooltip,
        contextMenu,
        onSelect
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, style)
    updatedStyle['cursor'] = !contextMenu || !onSelect ? 'default' : 'pointer'
    const content = <Tag styles={updatedStyle}>
                        {icon ? <Icon styles={updatedStyle}>{icon}</Icon> 
                        : img ? <img src={img} style={{width:'0.7rem', objectFit:'contain'}}/> 
                        :null}
                        {label}
                    </Tag>
    let element = contextMenu ? <PopOut trigger='leftClick' element={contextMenu}>{content}</PopOut> : content
    return (
        <Container styles={updatedStyle} onClick={onSelect}>
            {tooltip ? <Tooltip title={tooltip} placement='bottom' arrow={true}>{element}</Tooltip> : element}
        </Container>
    )
}

export default Properties;